import { getAdminMinioCredentials } from '@api/graphql/types';

export enum FileActionType {
    storeAdminMinioCredentials = '@file/storeAdminMinioCredentials',
}

interface ActionType {
    type: FileActionType;
}

export interface StoreAdminMinioCredentialsAction extends ActionType {
    credentials: getAdminMinioCredentials;
}

/**
 * Stores the Minio credentials in the Redux store
 * @param credentials Backend response containing the Minio credentials
 */
export function storeAdminMinioCredentials(credentials: getAdminMinioCredentials): StoreAdminMinioCredentialsAction {
    return {
        type: FileActionType.storeAdminMinioCredentials,
        credentials,
    };
}

export type FileAction = StoreAdminMinioCredentialsAction | ActionType;


// WEBPACK FOOTER //
// ./src/actions/fileActions.ts